export class DownloadedItem {
    _id: string;
    material: any;
    downloadDate: Date;
    user: any;
    hasSearchTerms;
    createdAt: Date;
    updatedAt: Date;  
}